"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

require("./Filters.css");

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _lib = require("@cimpress/react-components/lib");

var _treeSelector = _interopRequireDefault(require("@cimpress-technology/tree-selector"));

var _EditSavedSearch = _interopRequireDefault(require("./EditSavedSearch"));

var _CreateSavedSearch = _interopRequireDefault(require("./CreateSavedSearch"));

var _apis = require("../../../services/apis");

var _snackbar = require("../../../actions/snackbar");

var _snackbarStatus = require("../../../constants/snackbarStatus");

var _filters = require("../../../constants/filters");

var _filters2 = require("../../../services/filters");

var _environment = require("../../../constants/environment");

var _useSavedSearch2 = _interopRequireDefault(require("../../../customHooks/useSavedSearch"));

var _SelectExpectedShipDate = _interopRequireDefault(require("./SelectExpectedShipDate"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function Filters(_ref) {
  var accessToken = _ref.accessToken,
      _ref$environment = _ref.environment,
      environment = _ref$environment === void 0 ? _environment.ENVIRONMENT.PRODUCTION : _ref$environment,
      _ref$fulfiller = _ref.fulfiller;
  _ref$fulfiller = _ref$fulfiller === void 0 ? {} : _ref$fulfiller;
  var fulfillerId = _ref$fulfiller.fulfillerId,
      fulfillerName = _ref$fulfiller.name,
      _ref$filterList = _ref.filterList,
      filterList = _ref$filterList === void 0 ? [] : _ref$filterList,
      externalFilters = _ref.externalFilters,
      show = _ref.show,
      onApplyFilters = _ref.onApplyFilters,
      onCancelFilters = _ref.onCancelFilters,
      onChangeSelectedSearch = _ref.onChangeSelectedSearch,
      _ref$filterPrecedence = _ref.filterPrecedence,
      filterPrecedence = _ref$filterPrecedence === void 0 ? _filters.FILTER_PRECEDENCE.DEFAULT : _ref$filterPrecedence,
      _ref$selectedFilters = _ref.selectedFilters,
      selectedFilters = _ref$selectedFilters === void 0 ? {} : _ref$selectedFilters,
      selectedSearch = _ref.selectedSearch,
      showSnackbar = _ref.showSnackbar;

  var _useState = (0, _react.useState)([]),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      filtersConfig = _useState2[0],
      setFiltersConfig = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      showDrawer = _useState4[0],
      setShowDrawer = _useState4[1];

  var _useState5 = (0, _react.useState)({}),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      currentFilters = _useState6[0],
      setCurrentFilters = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      showEditModal = _useState8[0],
      setShowEditModal = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
      showSaveModal = _useState10[0],
      setShowSaveModal = _useState10[1];

  var _useState11 = (0, _react.useState)(),
      _useState12 = (0, _slicedToArray2["default"])(_useState11, 2),
      savedSearchState = _useState12[0],
      setSavedSearchState = _useState12[1];

  var _useState13 = (0, _react.useState)(false),
      _useState14 = (0, _slicedToArray2["default"])(_useState13, 2),
      showLocalCurrencyAlert = _useState14[0],
      setShowLocalCurrencyAlert = _useState14[1];

  var _useState15 = (0, _react.useState)([]),
      _useState16 = (0, _slicedToArray2["default"])(_useState15, 2),
      selectedCategory = _useState16[0],
      setSelectedCategory = _useState16[1];

  var _useState17 = (0, _react.useState)({}),
      _useState18 = (0, _slicedToArray2["default"])(_useState17, 2),
      sharedFilters = _useState18[0],
      setSharedFilters = _useState18[1];

  var _useState19 = (0, _react.useState)([]),
      _useState20 = (0, _slicedToArray2["default"])(_useState19, 2),
      savedSearches = _useState20[0],
      setSavedSearches = _useState20[1];

  var _useSavedSearch = (0, _useSavedSearch2["default"])({
    fulfillerId: fulfillerId,
    fulfillerName: fulfillerName,
    externalFilters: externalFilters,
    filterPrecedence: filterPrecedence,
    showSnackbar: showSnackbar,
    accessToken: accessToken
  }),
      isLoading = _useSavedSearch.isLoading,
      userSavedSearches = _useSavedSearch.userSavedSearches,
      sharedFilterValues = _useSavedSearch.sharedFilterValues;

  var updateLastSearched = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(updatedFilters) {
      var _sharedFilters;

      var currency, timeFrame, sharedFilters, exclusiveFilters, newSavedSearchList, lastSearchedFilters, sharedFiltersToSave, _yield$updateUserSett, updatedSavedSearches, updatedSharedFilters, _error$response;

      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // saving only CURRENCY and TIME_FRAME as part of sharedFilters
              currency = updatedFilters[_filters.CURRENCY.name], timeFrame = updatedFilters[_filters.TIME_FRAME.name];
              sharedFilters = (_sharedFilters = {}, (0, _defineProperty2["default"])(_sharedFilters, _filters.CURRENCY.name, currency), (0, _defineProperty2["default"])(_sharedFilters, _filters.TIME_FRAME.name, timeFrame), _sharedFilters); // removing SHARED_FILTERS and REFERENCE_DATE from exclusive filters before saving

              exclusiveFilters = _objectSpread({}, updatedFilters);
              [_filters.CURRENCY, _filters.TIME_FRAME, _filters.REFERENCE_DATE].forEach(function (filterName) {
                return delete exclusiveFilters[filterName.name];
              });
              newSavedSearchList = savedSearches.filter(function (search) {
                return !search.isLast;
              });
              lastSearchedFilters = {
                label: _filters.LAST_SEARCHED,
                value: exclusiveFilters,
                isDefault: false,
                isLast: true
              };
              newSavedSearchList.push(lastSearchedFilters);
              sharedFiltersToSave = {
                label: _filters.LAST_SEARCHED,
                value: sharedFilters,
                isDefault: false,
                isLast: true
              };
              _context.prev = 8;
              _context.next = 11;
              return (0, _apis.updateUserSettings)({
                environment: environment,
                accessToken: accessToken
              }, {
                key: fulfillerId,
                updatedUserSettings: newSavedSearchList,
                updatedSharedSettings: sharedFiltersToSave
              });

            case 11:
              _yield$updateUserSett = _context.sent;
              updatedSavedSearches = _yield$updateUserSett.updatedSavedSearches;
              updatedSharedFilters = _yield$updateUserSett.updatedSharedFilters;
              setSavedSearches(updatedSavedSearches);
              setSharedFilters(updatedSharedFilters);
              _context.next = 21;
              break;

            case 18:
              _context.prev = 18;
              _context.t0 = _context["catch"](8);
              console.error((_context.t0 === null || _context.t0 === void 0 ? void 0 : (_error$response = _context.t0.response) === null || _error$response === void 0 ? void 0 : _error$response.data) || (_context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.response) || _context.t0);

            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[8, 18]]);
    }));

    return function updateLastSearched(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var checkToShowLocalCurrency = function checkToShowLocalCurrency(filtersObject) {
    var _filtersObject$CURREN;

    setShowLocalCurrencyAlert(filtersObject && ((_filtersObject$CURREN = filtersObject[_filters.CURRENCY.name]) === null || _filtersObject$CURREN === void 0 ? void 0 : _filtersObject$CURREN.value) === 'LOCAL');
  };

  var onFilterChange = function onFilterChange(valueObj) {
    // if from currenct dropdown local currency is selected or if it is already selected
    var newFilters = _objectSpread(_objectSpread({}, currentFilters), valueObj);

    checkToShowLocalCurrency(newFilters);
    setCurrentFilters(newFilters);
  };

  var areFiltersValid = function areFiltersValid() {
    var _ref3 = (currentFilters === null || currentFilters === void 0 ? void 0 : currentFilters[_filters.FILTER_NAMES.EXPECTED_SHIP_DATE]) || {},
        start = _ref3.start,
        end = _ref3.end;

    if (start && !end || !start && end) {
      showSnackbar({
        status: _snackbarStatus.SNACKBAR_STATUS.DANGER,
        message: "For 'Expected Ship Date' either provide both Start and End Date or clear both!"
      });
      return false;
    }

    return true;
  };

  var apply = /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!areFiltersValid()) {
                _context2.next = 5;
                break;
              }

              if (onChangeSelectedSearch) onChangeSelectedSearch(savedSearchState);
              if (onApplyFilters) onApplyFilters(currentFilters);
              _context2.next = 5;
              return updateLastSearched(currentFilters);

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function apply() {
      return _ref4.apply(this, arguments);
    };
  }();

  var cancel = function cancel() {
    setCurrentFilters(selectedFilters);
    setSavedSearchState(selectedSearch);
    if (onCancelFilters) onCancelFilters();
  };

  var clear = function clear() {
    setCurrentFilters(function (previousFilters) {
      var updatedFilters = _objectSpread({}, previousFilters);

      filtersConfig.forEach(function (_ref5) {
        var isClearable = _ref5.isClearable,
            name = _ref5.name;
        if (isClearable) updatedFilters[name] = null;
      });
      return updatedFilters;
    });
    setSavedSearchState(null);
  };

  var onSelectSavedSearch = function onSelectSavedSearch(savedSearch) {
    if ((savedSearch === null || savedSearch === void 0 ? void 0 : savedSearch.label) === _filters.LAST_SEARCHED) {
      savedSearch.value = _objectSpread(_objectSpread({}, savedSearch.value), sharedFilters.value);
    }

    setCurrentFilters(savedSearch === null || savedSearch === void 0 ? void 0 : savedSearch.value);
    setSavedSearchState(savedSearch); // if the saved search is changed and it contains local currency

    checkToShowLocalCurrency(savedSearch === null || savedSearch === void 0 ? void 0 : savedSearch.value);
  };
  /********** Child Component functions **********/


  var showSavedSearchModal = function showSavedSearchModal() {
    setShowEditModal(true);
  };

  var hideSavedSearchModal = function hideSavedSearchModal() {
    setShowEditModal(false);
  };

  var showNameModal = function showNameModal() {
    setShowSaveModal(true);
  };

  var hideNameModal = function hideNameModal() {
    setShowSaveModal(false);
  };

  var setSearchName = /*#__PURE__*/function () {
    var _ref6 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(searchName) {
      var filtersToSave, newSavedSearch, _savedSearches$filter, _yield$updateUserSett2, updatedSetting, _error$response2;

      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              filtersToSave = _objectSpread({}, currentFilters);
              delete filtersToSave[_filters.REFERENCE_DATE.name]; // removing reference date before saving

              newSavedSearch = {
                label: searchName,
                value: filtersToSave,
                isDefault: false
              };
              _context3.prev = 3;

              if (!((_savedSearches$filter = savedSearches.filter(function (setting) {
                return setting.label === newSavedSearch.label;
              })) !== null && _savedSearches$filter !== void 0 && _savedSearches$filter.length)) {
                _context3.next = 8;
                break;
              }

              showSnackbar({
                status: _snackbarStatus.SNACKBAR_STATUS.DANGER,
                message: 'Name already exists! Either change the name or delete the existing search to continue.'
              });
              _context3.next = 14;
              break;

            case 8:
              _context3.next = 10;
              return (0, _apis.updateUserSettings)({
                environment: environment,
                accessToken: accessToken
              }, {
                key: fulfillerId,
                updatedUserSettings: [].concat((0, _toConsumableArray2["default"])(savedSearches), [newSavedSearch])
              });

            case 10:
              _yield$updateUserSett2 = _context3.sent;
              updatedSetting = _yield$updateUserSett2.updatedSavedSearches;
              setSavedSearches(updatedSetting);
              setShowSaveModal(false);

            case 14:
              _context3.next = 20;
              break;

            case 16:
              _context3.prev = 16;
              _context3.t0 = _context3["catch"](3);
              console.error((_context3.t0 === null || _context3.t0 === void 0 ? void 0 : (_error$response2 = _context3.t0.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.data) || (_context3.t0 === null || _context3.t0 === void 0 ? void 0 : _context3.t0.response) || _context3.t0);
              showSnackbar({
                status: _snackbarStatus.SNACKBAR_STATUS.DANGER,
                message: 'Error while saving filter! Please reload page & try again.'
              });

            case 20:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[3, 16]]);
    }));

    return function setSearchName(_x2) {
      return _ref6.apply(this, arguments);
    };
  }();

  var deleteSavedSearch = function deleteSavedSearch(searchName) {
    savedSearches.forEach( /*#__PURE__*/function () {
      var _ref7 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(search, index) {
        var _deletedSearch$, newSavedSearchList, deletedSearch, _yield$updateUserSett3, updatedSetting, _error$response3;

        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                if (!(search.label === searchName)) {
                  _context4.next = 11;
                  break;
                }

                newSavedSearchList = (0, _toConsumableArray2["default"])(savedSearches);
                deletedSearch = newSavedSearchList.splice(index, 1);
                _context4.next = 6;
                return (0, _apis.updateUserSettings)({
                  environment: environment,
                  accessToken: accessToken
                }, {
                  key: fulfillerId,
                  updatedUserSettings: newSavedSearchList
                });

              case 6:
                _yield$updateUserSett3 = _context4.sent;
                updatedSetting = _yield$updateUserSett3.updatedSavedSearches;

                if (((_deletedSearch$ = deletedSearch[0]) === null || _deletedSearch$ === void 0 ? void 0 : _deletedSearch$.label) === (savedSearchState === null || savedSearchState === void 0 ? void 0 : savedSearchState.label)) {
                  if (onChangeSelectedSearch) onChangeSelectedSearch(null);
                }

                setSavedSearches(updatedSetting);
                setShowEditModal(false);

              case 11:
                _context4.next = 17;
                break;

              case 13:
                _context4.prev = 13;
                _context4.t0 = _context4["catch"](0);
                console.error((_context4.t0 === null || _context4.t0 === void 0 ? void 0 : (_error$response3 = _context4.t0.response) === null || _error$response3 === void 0 ? void 0 : _error$response3.data) || (_context4.t0 === null || _context4.t0 === void 0 ? void 0 : _context4.t0.response) || _context4.t0);
                showSnackbar({
                  status: _snackbarStatus.SNACKBAR_STATUS.DANGER,
                  message: 'Unable to delete the saved search! Please reload page & try again.'
                });

              case 17:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[0, 13]]);
      }));

      return function (_x3, _x4) {
        return _ref7.apply(this, arguments);
      };
    }());
  };

  var makeDefaultSearch = function makeDefaultSearch(searchName) {
    var newSavedSearchList = (0, _toConsumableArray2["default"])(savedSearches);
    newSavedSearchList.forEach(function (search) {
      return search.isDefault = false;
    });
    newSavedSearchList.forEach( /*#__PURE__*/function () {
      var _ref8 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(search, index) {
        var _yield$updateUserSett4, updatedSetting, _error$response4;

        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;

                if (!(search.label === searchName)) {
                  _context5.next = 9;
                  break;
                }

                newSavedSearchList[index].isDefault = true;
                _context5.next = 5;
                return (0, _apis.updateUserSettings)({
                  environment: environment,
                  accessToken: accessToken
                }, {
                  key: fulfillerId,
                  updatedUserSettings: newSavedSearchList
                });

              case 5:
                _yield$updateUserSett4 = _context5.sent;
                updatedSetting = _yield$updateUserSett4.updatedSavedSearches;
                setSavedSearches(updatedSetting);
                setShowEditModal(false);

              case 9:
                _context5.next = 15;
                break;

              case 11:
                _context5.prev = 11;
                _context5.t0 = _context5["catch"](0);
                console.error((_context5.t0 === null || _context5.t0 === void 0 ? void 0 : (_error$response4 = _context5.t0.response) === null || _error$response4 === void 0 ? void 0 : _error$response4.data) || (_context5.t0 === null || _context5.t0 === void 0 ? void 0 : _context5.t0.response) || _context5.t0);
                showSnackbar({
                  status: _snackbarStatus.SNACKBAR_STATUS.DANGER,
                  message: 'Unable to default the saved search! Please reload page & try again.'
                });

              case 15:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[0, 11]]);
      }));

      return function (_x5, _x6) {
        return _ref8.apply(this, arguments);
      };
    }());
  };

  (0, _react.useEffect)(function () {
    function fetchFiltersData() {
      return _fetchFiltersData.apply(this, arguments);
    }

    function _fetchFiltersData() {
      _fetchFiltersData = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7() {
        var config, _error$response5;

        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return Promise.all(filterList.map( /*#__PURE__*/function () {
                  var _ref9 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(filterName) {
                    var fulfillers, merchants, fulfillmentLocations;
                    return _regenerator["default"].wrap(function _callee6$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            if (!(filterName === _filters.FILTER_NAMES.CURRENCY)) {
                              _context6.next = 2;
                              break;
                            }

                            return _context6.abrupt("return", _filters.CURRENCY);

                          case 2:
                            if (!(filterName === _filters.FILTER_NAMES.TIME_FRAME)) {
                              _context6.next = 4;
                              break;
                            }

                            return _context6.abrupt("return", _filters.TIME_FRAME);

                          case 4:
                            if (!(filterName === _filters.FILTER_NAMES.FULFILLER)) {
                              _context6.next = 10;
                              break;
                            }

                            _context6.next = 7;
                            return (0, _filters2.getFulfillers)({
                              environment: environment,
                              accessToken: accessToken
                            });

                          case 7:
                            fulfillers = _context6.sent;
                            _filters.FULFILLER.options = fulfillers.map(function (_ref10) {
                              var name = _ref10.name,
                                  fulfillerId = _ref10.fulfillerId;
                              return {
                                label: name,
                                value: name,
                                id: fulfillerId
                              };
                            });
                            return _context6.abrupt("return", _filters.FULFILLER);

                          case 10:
                            if (!(filterName === _filters.FILTER_NAMES.MERCHANT)) {
                              _context6.next = 16;
                              break;
                            }

                            _context6.next = 13;
                            return (0, _filters2.getMerchants)({
                              environment: environment,
                              accessToken: accessToken
                            });

                          case 13:
                            merchants = _context6.sent;
                            _filters.MERCHANT.options = merchants.map(function (_ref11) {
                              var merchantId = _ref11.merchantId,
                                  displayName = _ref11.displayName;
                              return {
                                label: displayName,
                                value: merchantId,
                                id: merchantId
                              };
                            });
                            return _context6.abrupt("return", _filters.MERCHANT);

                          case 16:
                            if (!(filterName === _filters.FILTER_NAMES.FULFILLMENT_LOCATION)) {
                              _context6.next = 22;
                              break;
                            }

                            _context6.next = 19;
                            return (0, _filters2.getFulfillmentLocations)({
                              environment: environment,
                              accessToken: accessToken
                            });

                          case 19:
                            fulfillmentLocations = _context6.sent;
                            // in the fulfiller view, we filter the fulfillmentLocation options based on fulfillerId
                            _filters.FULFILLMENT_LOCATION.options = (fulfillerId ? _.sortBy(fulfillmentLocations, 'name').filter(function (_ref12) {
                              var locationFulfillerId = _ref12.fulfillerId;
                              return fulfillerId === locationFulfillerId;
                            }) : _.sortBy(fulfillmentLocations, 'name')).map(function (_ref13) {
                              var name = _ref13.name,
                                  fulfillmentLocationId = _ref13.fulfillmentLocationId,
                                  fulfillerId = _ref13.fulfillerId;
                              return {
                                label: "".concat(name, " (").concat(fulfillerId, ")"),
                                value: fulfillmentLocationId,
                                id: fulfillmentLocationId
                              };
                            });
                            return _context6.abrupt("return", _filters.FULFILLMENT_LOCATION);

                          case 22:
                            if (!(filterName === _filters.FILTER_NAMES.EXPECTED_SHIP_DATE)) {
                              _context6.next = 24;
                              break;
                            }

                            return _context6.abrupt("return", _filters.EXPECTED_SHIP_DATE);

                          case 24:
                            if (!(filterName === _filters.FILTER_NAMES.PRODUCT_CATEGORY)) {
                              _context6.next = 26;
                              break;
                            }

                            return _context6.abrupt("return", _filters.PRODUCT_CATEGORY);

                          case 26:
                          case "end":
                            return _context6.stop();
                        }
                      }
                    }, _callee6);
                  }));

                  return function (_x7) {
                    return _ref9.apply(this, arguments);
                  };
                }()));

              case 3:
                config = _context7.sent;
                setFiltersConfig(config);
                _context7.next = 11;
                break;

              case 7:
                _context7.prev = 7;
                _context7.t0 = _context7["catch"](0);
                console.error((_context7.t0 === null || _context7.t0 === void 0 ? void 0 : (_error$response5 = _context7.t0.response) === null || _error$response5 === void 0 ? void 0 : _error$response5.data) || (_context7.t0 === null || _context7.t0 === void 0 ? void 0 : _context7.t0.response) || _context7.t0);
                showSnackbar({
                  status: _snackbarStatus.SNACKBAR_STATUS.DANGER,
                  message: 'Error while fetching filters! Please try reloading.'
                });

              case 11:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, null, [[0, 7]]);
      }));
      return _fetchFiltersData.apply(this, arguments);
    }

    if (filterList.length) fetchFiltersData();
  }, [].concat((0, _toConsumableArray2["default"])(filterList), [showSnackbar]));
  (0, _react.useEffect)(function () {
    setShowDrawer(show); // show alert if incoming filters have local currency selected

    checkToShowLocalCurrency(currentFilters);
  }, [show, currentFilters]);
  (0, _react.useEffect)(function () {
    setCurrentFilters(selectedFilters);
    setSavedSearchState(selectedSearch);
  }, [selectedSearch, selectedFilters]);
  (0, _react.useEffect)(function () {
    if (!isLoading) {
      setSavedSearches(userSavedSearches);
      setSharedFilters(sharedFilterValues);
    }
  }, [isLoading, userSavedSearches, sharedFilterValues]);
  return /*#__PURE__*/_react["default"].createElement(_lib.Drawer, {
    position: "right",
    show: showDrawer,
    onRequestHide: cancel,
    header: "Filters",
    footer: /*#__PURE__*/_react["default"].createElement("div", {
      className: "filters-flex-container"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "filters-flex-item-left"
    }, /*#__PURE__*/_react["default"].createElement(_lib.Button, {
      variant: 'primary',
      onClick: apply
    }, "Apply")), /*#__PURE__*/_react["default"].createElement("div", {
      className: "filters-flex-item-left"
    }, /*#__PURE__*/_react["default"].createElement(_lib.Button, {
      onClick: showNameModal
    }, "Save")), /*#__PURE__*/_react["default"].createElement("div", {
      className: "filters-flex-item-right"
    }, /*#__PURE__*/_react["default"].createElement(_lib.Button, {
      onClick: clear
    }, "Clear Filters")))
  }, /*#__PURE__*/_react["default"].createElement(_lib.Select, {
    key: 'saved-search',
    name: 'Saved Search',
    isClearable: false,
    isMulti: false,
    label: 'Saved Search',
    options: savedSearches,
    onChange: function onChange(value) {
      return onSelectSavedSearch(value);
    },
    value: savedSearchState || null
  }), /*#__PURE__*/_react["default"].createElement(_lib.Button, {
    variant: "anchor",
    onClick: showSavedSearchModal
  }, "Set saved search as default"), /*#__PURE__*/_react["default"].createElement(_EditSavedSearch["default"], {
    name: "edit saved search",
    label: "Set saved search as default",
    savedSearches: savedSearches,
    onDefault: function onDefault(value) {
      return makeDefaultSearch(value);
    },
    onDelete: function onDelete(value) {
      return deleteSavedSearch(value);
    },
    showModal: showEditModal,
    closeModal: hideSavedSearchModal
  }), /*#__PURE__*/_react["default"].createElement(_CreateSavedSearch["default"], {
    label: "Enter search name",
    showModal: showSaveModal,
    closeModal: hideNameModal,
    onSave: function onSave(name) {
      return setSearchName(name);
    }
  }), /*#__PURE__*/_react["default"].createElement("hr", null), filtersConfig.map(function (_ref14, index) {
    var name = _ref14.name,
        isClearable = _ref14.isClearable,
        isMulti = _ref14.isMulti,
        label = _ref14.label,
        helpText = _ref14.helpText,
        options = _ref14.options;

    if (name === _filters.FILTER_NAMES.EXPECTED_SHIP_DATE) {
      var _currentFilters$name, _currentFilters$name2;

      return /*#__PURE__*/_react["default"].createElement(_SelectExpectedShipDate["default"], {
        name: name,
        isClearable: isClearable,
        onChange: function onChange(value) {
          onFilterChange((0, _defineProperty2["default"])({}, name, value));
        },
        options: options,
        value: currentFilters !== null && currentFilters !== void 0 && currentFilters[name] ? {
          start: (_currentFilters$name = currentFilters[name]) === null || _currentFilters$name === void 0 ? void 0 : _currentFilters$name.start,
          end: (_currentFilters$name2 = currentFilters[name]) === null || _currentFilters$name2 === void 0 ? void 0 : _currentFilters$name2.end
        } : null
      });
    } else if (name === _filters.FILTER_NAMES.PRODUCT_CATEGORY) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/_react["default"].createElement(_treeSelector["default"], {
        token: accessToken,
        multiple: isMulti,
        onChange: function onChange(value) {
          var categoryValue = value.map(function (categoryId) {
            return {
              value: categoryId
            };
          });
          onFilterChange((0, _defineProperty2["default"])({}, name, categoryValue));
        },
        value: currentFilters !== null && currentFilters !== void 0 && currentFilters[name] ? currentFilters[name].map(function (category) {
          return category.value;
        }) : null,
        spinner: true,
        required: false,
        className: "tree-selector-border"
      }), /*#__PURE__*/_react["default"].createElement("small", null, helpText));
    }

    return /*#__PURE__*/_react["default"].createElement(_lib.Select, {
      key: "".concat(name, "-").concat(index),
      name: name,
      isClearable: isClearable,
      isMulti: isMulti,
      label: label,
      helpText: helpText,
      options: options,
      onChange: function onChange(value) {
        setSavedSearchState(null);
        onFilterChange((0, _defineProperty2["default"])({}, name, value));
      },
      value: currentFilters[name] || null
    });
  }), filterList.includes(_filters.FILTER_NAMES.CURRENCY) && showLocalCurrencyAlert && /*#__PURE__*/_react["default"].createElement(_lib.Alert, {
    status: 'warning',
    dismissible: false,
    message: "We would recommend using EUR (Euro) or USD currency, if your supplier network has orders in multiple local currencies."
  }));
}

var _default = (0, _reactRedux.connect)(null, {
  showSnackbar: _snackbar.showSnackbar
})(Filters);

exports["default"] = _default;